const FONT_AWESOME_API = 'https://kit.fontawesome.com/';
const COMMON_KIT_ID = '9a6054bfdd';

const useFontAwesome = () => {
  const script = document.createElement('script');
  script.src = `${FONT_AWESOME_API}${COMMON_KIT_ID}.js`;

  document.head.appendChild(script);
};

export default useFontAwesome;
